import styled from 'styled-components';

export const CtBody = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  @media (max-width: 950px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CtBodyInputContainer = styled.div`
  display: flex;
`;
export const CtBodyInputContainerInitial = styled.div`
  display: flex;
  max-width: 75px;
`;

export const CtFooter = styled.div`
  border-top: 1px solid var(--LightGray);
  justify-content: flex-end;
  padding: 30px 30px;
  margin-top: 20px;
  min-width: 292px;
  display: flex;
`;

export const CtBodyLeft = styled.div`
  margin: 30px 20px 10px 40px;
  border: 1px dotted #bac1c9;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  min-width: 292px;
  padding: 20px 0;
  display: flex;
`;

export const CtBodyLeftWrapper = styled.div`
  margin: 10px 0;
`;

export const CtBodyRigth = styled.div`
  margin: 30px 40px 10px 20px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  min-width: 292px;
  display: flex;
`;

export const CtBodyRigthWrapper = styled.div`
  width: 100%;
`;

export const CtBodyRigthWrapperBottom = styled.div`
  justify-content: flex-start;
  display: flex;
  width: 100%;
`;

export const CtBodyRigthWrapperBottomInner = styled.div`
  margin-right: 20px;
`;
